import React, { useState } from "react";
import "../../styles/Css/FoundingMembers.css";

const FoundingMemberSection = () => {
    const [formData, setFormData] = useState({ first_name: '', last_name: '', email: '', phone: '', brokerage: '', role: '' });


    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
    };

    return (
        <section className="founding" id="signup">
            <div className="founding__container">
                <span className="founding__badge badge" style={{ cursor: "pointer" }}>LIMITED TIME OFFER</span>
                <h2 className="founding__title">Join the First 300 Founding Users</h2>
                <p className="founding__subtitle">
                    We're onboarding users in limited batches to ensure the best experience. Get exclusive founding member benefits.
                </p>

                <div className="founding__offer">
                    <span className="founding__offer-badge" style={{ cursor: "pointer" }}>$10/month LOCKED FOR LIFE</span>
                    <span className="founding__offer-note">Founding member exclusive price</span>
                </div>

                <div className="founding__benefits">
                    <div className="founding__benefit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Priority access to new features
                    </div>
                    <div className="founding__benefit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        1-on-1 onboarding support
                    </div>
                    <div className="founding__benefit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Lifetime pricing guarantee
                    </div>
                    <div className="founding__benefit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Direct line to product team
                    </div>
                    <div className="founding__benefit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Founding member badge
                    </div>
                    <div className="founding__benefit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Influence product roadmap
                    </div>
                </div>

                <form className="founding__form" onSubmit={handleSubmit}>
                    <div className="founding__form-row">
                        <input
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            value={formData.first_name}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={formData.last_name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        name="brokerage"
                        placeholder="Brokerage or Company Name"
                        value={formData.brokerage}
                        onChange={handleInputChange}
                    />
                    <select
                        name="role"
                        value={formData.role}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select Your Role</option>
                        <option value="agent">Real Estate Agent</option>
                        <option value="broker">Broker</option>
                        <option value="tc">Transaction Coordinator</option>
                        <option value="team-lead">Team Lead</option>
                        <option value="other">Other</option>
                    </select>
                    <button type="submit" className="btn btn-primary btn-lg founding__submit">
                        Join the Waitlist
                    </button>
                    <span className="founding__form-note" style={{ cursor: "pointer" }}>
                        Join 200+ agents already on the waitlist
                    </span>
                </form>
            </div>
        </section>
    );
};

export default FoundingMemberSection;
